import { createReducer } from 'typesafe-actions';

import { IUsersState, TUsersAction, UsersActionTypes } from '@/store/types/users.types';

const initialState: IUsersState = {
  paginateUsers: {
    elements: [],
    pagination: {
      totalPages: 0,
      currentPage: 0,
    },
  },
  isLoading: false,
};

export const usersReducer = createReducer<IUsersState, TUsersAction>(initialState)
  .handleType(UsersActionTypes.GET_USERS, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  })

  .handleType(UsersActionTypes.GET_USERS_SUCCESS, (state, action) => {
    return {
      ...state,
      paginateUsers: { elements: action.users, pagination: action.pagination },
      isLoading: false,
      error: undefined,
    };
  })

  .handleType(UsersActionTypes.GET_USERS_FAIL, (state, action) => {
    return {
      ...state,
      isLoading: false,
      error: action.error,
    };
  });
